'use client'
import Image from "next/image";
import "../../styles/common/header.scss";
import Navbar from "../Navbar/navbar";
import { iMenu } from "@/app/models/iMenu";
import { iCustomStyling } from "@/app/models/configurations";
import { iImagePicker } from "@/app/models/blockTypes/imagePicker";
import { ReplaceOrgName } from "@/app/helpers/clientUtilityHelper";

interface Props {
  isLoggedIn: boolean;
  country: string;
  menu: iMenu;
  loginText: string;
  myPagesText: string;
  customStyling?: iCustomStyling;
  translations: any;
  temporaryOrgName?: string;
}

export default function ClientHeader({ isLoggedIn, country, menu, loginText, myPagesText, customStyling, translations,temporaryOrgName }: Props) {
  menu.myPagesLoginLink.linkText = loginText;
  menu.myPagesLoggedInLink.linkText = myPagesText;
  const useCustomHeaderLogo = customStyling?.useSpecialStyling && customStyling?.headerLogo && customStyling.headerLogo.length > 0;

  return (
    <header className="header fixed w-full z-50 h-20 top-0 bg-gs-green-400 flex items-center">
      <div className="container mx-auto flex items-center px-6 xl:p-0 justify-between">
        <a href={`/${country}/`} className="logo">
          {!useCustomHeaderLogo ? (
            <Image
              src="/images/gs_logo_white.svg"
              width={216}
              height={32}
              alt={ReplaceOrgName(translations.general.organization, temporaryOrgName)}
              priority
              className="h-auto max-h-[60px] w-[216px] lg:w-[auto] lg:h-[35px]"
            />
          ) : (
            customStyling.headerLogo.map((logo: iImagePicker, index: number) => (
              <img
                key={index}
                src={logo.url}
                alt={ReplaceOrgName(translations.general.organization, temporaryOrgName)}
                className="h-auto max-h-[60px] w-[216px] lg:w-[auto] lg:h-[35px]"
              />
            ))
          )}
        </a>
        {menu && <Navbar isLoggedIn={isLoggedIn} menu={menu} />}
      </div>
    </header>
  );
}
